// Copy and sizes for the marketing site mockups. See SiteMockups.tsx.
//
// The words in here are placeholders that marketing owns. They are written down
// so a composition is not half a picture, not because this is the wording: every
// string in CALLOUTS and every `label` is Chloe's to replace.

/**
 * The export sizes, taken off the three references in #marketing.
 *
 * Fixed rather than responsive, because the output is a crop at a known size
 * rather than a page that has to work at any width. A frame is the canvas, and
 * the fragments inside it bleed off its edges on purpose.
 */
export const FRAMES = {
  /** Reference 1: the layered group, near square. */
  hero: { width: 1100, height: 860 },
  /** Reference 3: two surfaces, one of them behind. */
  heroWide: { width: 1200, height: 800 },
  /** Reference 2: one surface, generous margin. */
  feature: { width: 1200, height: 680 },
  /**
   * Not one of the three: a phone is portrait, and a device sitting in a
   * landscape crop is a phone in a field of ground. Sized to the device with
   * the same margin the feature pieces leave around their surface.
   */
  device: { width: 560, height: 760 },
} as const;

/**
 * Pill callouts. One per composition at most: the reference uses them to name
 * the thing being pointed at, and two of them turns the picture into a diagram.
 *
 * These say what a care expert does, not what Tell Us Once will do. Nothing on
 * the site can point at a claim that filled itself in, because that is not live
 * and the site is not where we announce it.
 */
export const CALLOUTS = {
  claim: 'An expert does the claim with you',
  conversation: 'A care expert who knows your case',
  expert: 'Speak to a care expert',
} as const;

/** What sits above each frame in Loft, so you know what you are cropping. */
export const LABELS = {
  hero: 'Homepage · layered group',
  heroWide: 'Homepage · two surfaces',
  featureConversation: 'Feature · expert help',
  /** A call, which is a thing CAM logs today rather than something coming. */
  call: 'Phone · a video call',
  callWithApp: 'Phone and app · a video call',
  featureActions: 'Feature · actions',
  featureClaims: 'Feature · what you could claim',
} as const;

/**
 * The exchange in the conversation fragments.
 *
 * A care expert offering to do a claim and book a call, which is what happens
 * today. It used to be the intake asking who you are arranging care for and
 * promising to keep the answer, which is the Tell Us Once pitch and reads as an
 * announcement of it.
 */
export const CONVERSATION: { from: 'keni' | 'user'; text: string }[] = [
  {
    from: 'keni',
    text: 'I can help with your mum’s Attendance Allowance claim.',
  },
  { from: 'user', text: 'Where do I even start with it?' },
  {
    from: 'keni',
    text: 'We will do it together. I have Thursday at 10 or Friday at 2.',
  },
];
